import React from 'react';

/**
 * Official GIISDEC brand mark — the rising "ray fan" emblem rendered as an
 * inline SVG using the authoritative brand palette (window gray, Nikon yellow,
 * viridian green, coffee brown). Self-contained so favicon/build never depend
 * on a remote asset being reachable. See Documentation/BRANDING_ASSET_PACK.md.
 */
export const GiisdecMark: React.FC<{ className?: string; title?: string }> = ({
  className = 'w-9 h-9',
  title = 'GIISDEC',
}) => (
  <svg
    viewBox="0 0 64 64"
    role="img"
    aria-label={title}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title}</title>
    {/* Four diagonal rays fanning up from a common base — brand palette */}
    <g transform="rotate(-18 32 32)">
      <rect x="10" y="6"  width="9" height="40" rx="2" fill="#cfd0cf" />
      <rect x="22" y="10" width="9" height="40" rx="2" fill="#ffe600" />
      <rect x="34" y="14" width="9" height="40" rx="2" fill="#40826d" />
      <rect x="46" y="18" width="9" height="40" rx="2" fill="#6f4e37" />
    </g>
  </svg>
);

interface BrandLogoProps {
  /** 'light' = for dark backgrounds (white wordmark); 'dark' = royal-blue wordmark */
  variant?: 'light' | 'dark';
  showWordmark?: boolean;
  className?: string;
  /** Override the identity subtitle (e.g. "Geo-Information Portal"). Defaults to the corporate name. */
  subtitle?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  variant = 'light',
  showWordmark = true,
  className = '',
  subtitle = 'Ghana Integrated Iron & Steel Dev. Corp.',
}) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-[#002366]';
  const subColor = variant === 'light' ? 'text-white/60' : 'text-eds-muted-fg';

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <GiisdecMark className="w-9 h-9 flex-shrink-0" />
      {showWordmark && (
        <div className="leading-tight">
          <div className={`font-eds-display font-bold text-lg tracking-tight ${textColor}`}>GIISDEC</div>
          <div className={`text-[9px] uppercase tracking-widest ${subColor}`}>
            {subtitle}
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandLogo;
